import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import { useCfind6099JiraGoogleOnlySocialProviders } from "@/components/signup/hooks";
import { JiraOverlayTemplate } from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    GetStartedHeading,
    GetStartedText,
    Headings,
    InputSubmitButton
} from "../../../components";

export const LoggedOutJiraStandard = () => {
    const socialSignupProviders = useCfind6099JiraGoogleOnlySocialProviders();

    const intl = useIntl();

    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.standard",
        defaultMessage:
            "14-day free trial for unlimited users on the Standard plan — no credit card needed"
    });

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <JiraOverlayTemplate size="sm">
            {team26VisualUpdates ? (
                <Headings
                    main={<GetStartedText productName="Jira" />}
                    sub={heading2}
                />
            ) : (
                <>
                    <GetStartedHeading productName="Jira" />
                    <p css={subHeaderCss}>{heading2}</p>
                </>
            )}
            <AccountCreation
                Input={<InputSubmitButton />}
                Social={<Social providers={socialSignupProviders} />}
                Submit={null}
            />
        </JiraOverlayTemplate>
    );
};

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
